import { Icon, PanelType } from '../../fluent';
import { StandarPanel } from './StandarPanel';
import React from 'react';
import { Column } from './Column';
import { isNullOrEmpty } from '../helpers/string-helper';
import { Grid } from './Grid';
import { Row } from './Row';
const boxStyte = {
    padding: '15px',
    marginTop: '20px'
};
export class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: this._processMetadata(props.notifications || []),
            show: props.show || false
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            notifications: this._processMetadata(props.notifications || []),
            show: props.show || false
        });
    }
    renderDefaultItem(notification) {
        return React.createElement("div", { className: "ms-depth-4 x-hidden-focus", style: boxStyte },
            React.createElement("span", { style: { fontWeight: 'bold' } }, notification.Title),
            React.createElement(Icon, { iconName: 'Cancel', onClick: () => this._removeNotification(notification), style: {
                    position: 'absolute',
                    top: '28px',
                    right: '15px',
                    cursor: 'pointer'
                } }),
            React.createElement("br", null),
            React.createElement("div", null, notification.Description),
            React.createElement("div", { style: { fontSize: '0.8em', textAlign: 'right' } }, notification.CreationDateTime));
    }
    render() {
        return React.createElement(StandarPanel, { isOpen: this.state.show, type: PanelType.smallFixedFar, headerText: 'Notificaciones', onClose: () => {
                this.props.onClose();
            }, onRender: () => React.createElement(Grid, null, this.state.notifications.map(notification => React.createElement(Row, null,
                React.createElement(Column, { size: 12 }, typeof this.props.onRenderItem === 'function' ? this.props.onRenderItem(notification) : this.renderDefaultItem(notification))))), hideAcceptButton: true });
    }
    _processMetadata(items) {
        return items.map(o => {
            if (!isNullOrEmpty(o.Metadata)) {
                try {
                    o.Props = JSON.parse(o.Metadata);
                }
                catch (error) { }
            }
            return o;
        });
    }
    _removeNotification(notification) {
        this.props.onRemove(notification);
    }
}
